import React from 'react';
import styled from 'styled-components';
import { palette } from '../../../system/styles/styles';
import BarLoader from 'react-spinners/BarLoader';
import { Tooltip } from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { Document, Page } from 'react-pdf';
import Download from '../../../system/access/images/ats/download.png';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { useTranslation } from 'react-i18next';
const MainContainer = styled.main`
  background-color: ${palette.white};
  height: calc(97vh - 50px);
  .Pages {
    position: absolute;
    width: 150px;
    height: 40px;
    border-radius: 8px;
    left: calc(30% - 75px + 1.2rem);
    top: calc(95vh - 108.8px);
    background-color: ${palette.white};
    box-shadow: 0 4px 15px 0 rgba(0, 0, 0, 0.3);
    justify-content: center;
    align-items: center;
    display: grid;
    opacity: 0;
    z-index: 10000;
    transition: 0.3s;
  }
  .Pages p {
    font-size: 20px;
    text-align: center;
    padding: 0px;
    margin: 0px;
    margin: auto;
  }
  .PagesShow {
    position: absolute;
    width: 180px;
    height: 40px;
    border-radius: 4px;
    left: calc(30% - 90px + 1.2rem);
    top: calc(95vh - 50px);
    background-color: ${palette.white};
    box-shadow: 0 4px 15px 0 rgba(0, 0, 0, 0.3);
    grid-template-columns: 40px 100px 40px 0px;
    display: grid;
    opacity: 1;
    z-index: 10000;
    transition: 0.3s;
  }
  .PagesShow p {
    font-size: 20px;
    text-align: center;
    padding: 0px;
    margin: 0px;
    margin: auto;
  }
  .PagesShow button {
    height: 40px;
    border-radius: 8px;
    background-color: ${palette.white};
    transition: 0.3s;
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    font-size: 1rem;
  }
  .PagesShow button:hover {
    background-color: ${palette.accent};
    transition: 0.3s;
    color: ${palette.white};
  }
  .PagesShow button:disabled {
    background-color: #ddd;
    cursor: auto;
    transition: 0.3s;
    color: ${palette.white};
  }
  .PagesShow a {
    width: 0px;
    opacity: 0;
    transition: 0.3s;
  }
  .PagesShow a:active,
  a:focus {
    outline: none;
  }
  .PagesShow:hover {
    width: 280px;
    left: calc(30% - 90px + 1.2rem);
    grid-template-columns: 40px 100px 40px 100px;
  }
  .PagesShow:hover a {
    width: 100px;
    opacity: 1;
    text-align: center;
    transition: 1s;
    text-decoration: none;
    color: ${palette.accent};
    font-size: 16px;
    padding: 8px 0px;
    margin: 0px;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    margin: auto;
  }
  .PagesShow:hover a:hover {
    color: #fff;
    background-color: $accent;
  }
  .PagesShow__sig {
    border-top-right-radius: 4px !important;
    border-bottom-right-radius: 4px !important;
    border-top-left-radius: 0px !important;
    border-bottom-left-radius: 0px !important;
  }
  .PagesShow__sig:active,
  .PagesShow__sig:focus {
    outline: none;
  }
  .ChangedPDF {
    width: 50px;
    height: 50px;
    position: absolute;
    left: calc(60% - 100px);
    background-color: ${palette.accent};
    top: calc(95vh - 100px);
    z-index: 10000;
    border-radius: 25px;
    box-shadow: 0 4px 15px 0 rgba(0, 0, 0, 0.3);
    opacity: 0.4;
    transition: 0.3s;
    transform: scale(1);
    justify-content: center;
    align-items: center;
    display: flex;
  }
  .ChangedPDF:hover {
    transform: scale(1.1);
    transition: 0.3s;
    opacity: 1;
  }
  .ChangedPDF img {
    width: 25px;
    height: 25px;
  }
  .Download {
    width: 50px;
    height: 50px;
    position: absolute;
    left: calc(60% - 100px);
    background-color: ${palette.accent};
    top: calc(95vh - 40px);
    z-index: 10000;
    border-radius: 25px;
    box-shadow: 0 4px 15px 0 rgba(0, 0, 0, 0.3);
    opacity: 0.4;
    transition: 0.3s;
    transform: scale(1);
    justify-content: center;
    align-items: center;
    display: flex;
  }
  .Download img {
    width: 25px;
    height: 25px;
  }
  .Download:hover {
    transform: scale(1.1);
    transition: 0.3s;
    opacity: 1;
  }
  .loading_pdf {
    height: calc(100vh - 50px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .loading_pdf p {
    font-family: 'pieza-bold', sans-serif;
    text-align: center;
    font-size: 1.5rem;
    margin: 10px 0px;
  }
  .Page {
    height: calc(100vh - 50px);
    background-color: ${palette.white};
    overflow-y: scroll;
  }
  .Page::-webkit-scrollbar {
    width: 0.5em;
    height: 0.5em;
  }
  .Page::-webkit-scrollbar-track {
    background-color: #f2f2f2;
  }
  .Page::-webkit-scrollbar-thumb {
    background-color: #ccc;
    border-radius: 0.5rem;
  }
  .react-pdf__Page__svg {
    width: 100% !important;
    height: auto !important;
  }
  .react-pdf__Page__svg svg {
    transform: scale(0.97);
    box-shadow: 0 4px 15px 0 rgba(0, 0, 0, 0.3);
    border-radius: 8px;
    width: 100% !important;
    min-width: 100%;
    height: auto;
  }
  .rpv-core__inner-page {
    padding: 2.5rem;
  }
  .error_container {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    .error_message {
      border-radius: 17px;
      background-color: #385a52;
      padding: 4px 12px;
      font-size: 14px;
      font-weight: 600;
      color: #ffffff;
      letter-spacing: 1px;
    }
  }
`;

const ViewPDF = (props) => {
  const { pageNumber, go_back, advance_page, cv, updateCV, load_success, className, docID, id, vacancyOwner } = props;
  let { fileID } = props;
  fileID = fileID.split('.');
  const dispatch = useDispatch();
  const [pages, setPages] = React.useState(1);
  const [error, setError] = React.useState(false);
  const [success, setSuccess] = React.useState('Pages');
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const { t } = useTranslation(['applicant']);
  const renderError = (error) => {
    let message = '';
    switch (error.name) {
      case 'InvalidPDFException':
        message = t('InvalidFile');
        break;
      case 'MissingPDFException':
        message = t('NoFile');
        break;
      case 'UnexpectedResponseException':
        message = t('ServerError');
        break;
      case 'n':
        message = t('ApiError');
        break;
      case 'UnknownErrorException':
        message = t('Ha habido un error al cargar el documento');
        break;
      default:
        message = t('NoFileFound');
        break;
    }
    return (
      <div className="error_container">
        <span className="error_message">{message}</span>
      </div>
    );
  };
  return (
    <MainContainer>
      <div className={success}>
        <button disabled={pageNumber === 1 ? true : false} onClick={() => go_back()}>
          {'<'}
        </button>
        <p>
          {pageNumber} de {pages}
        </p>
        <button
          className="PagesShow__sig"
          disabled={pageNumber === pages ? true : false}
          onClick={() => advance_page()}>
          {'>'}
        </button>
        <a target="_blank" href={cv}>
          Descargar
        </a>
      </div>
      <Tooltip title="Descargar" placement="top" arrow>
        <a className="Download" href={cv} target="_blank">
          <img src={Download} alt="Descargar" />
        </a>
      </Tooltip>
      <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.6.347/build/pdf.worker.min.js">
        {cv && (
          <Viewer
            fileUrl={cv}
            plugins={[defaultLayoutPluginInstance]}
            renderError={renderError}
            initialPage={0}
            renderLoader={(percentages) => (
              <div className="loading_pdf">
                <BarLoader sizeUnit="px" size={750} color={palette.blue} />
                <p>
                  {t('LoadingPDF')} {`${Math.round(percentages)}%`}
                </p>
              </div>
            )}
          />
        )}
      </Worker>
      {/*<Document*/}
      {/*    file={cv}*/}
      {/*    onLoadSuccess={(e) => {*/}
      {/*        load_success(e)*/}
      {/*        setPages(e.numPages)*/}
      {/*        setSuccess('PagesShow')*/}
      {/*    }}*/}
      {/*    renderMode="svg"*/}
      {/*    width={'100%'}*/}
      {/*    onZoom={true}*/}
      {/*    noData={*/}
      {/*        <div className="loading_pdf">*/}
      {/*            <p>No hay archivo.</p>*/}
      {/*        </div>*/}
      {/*    }*/}
      {/*    height={'auto'}*/}
      {/*    error={*/}
      {/*        error ?*/}
      {/*            <div className="loading_pdf">*/}
      {/*                <p>Error, archivo corrupto.</p>*/}
      {/*                <p>Hemos intentado convertir el archivo, pero fallamos en el intento.</p>*/}
      {/*            </div>*/}
      {/*            :*/}
      {/*            <div className="loading_pdf">*/}
      {/*                <BarLoader*/}
      {/*                    sizeUnit={"px"}*/}
      {/*                    size={750}*/}
      {/*                    color={'#F3764F'}*/}
      {/*                />*/}
      {/*                <p>Archivo .{fileID[1]}, intentando convertir.</p>*/}
      {/*                <p>Espere por favor...</p>*/}
      {/*                <p>Al convertir el archivo podría modificarse ligeramente.</p>*/}
      {/*            </div>*/}
      {/*    }*/}
      {/*    loading={*/}
      {/*        <div className="loading_pdf">*/}
      {/*            <BarLoader*/}
      {/*                sizeUnit={"px"}*/}
      {/*                size={750}*/}
      {/*                color={'#F3764F'}*/}
      {/*            />*/}
      {/*            <p>Cargando PDF</p>*/}
      {/*        </div>*/}
      {/*    }*/}
      {/*>*/}
      {/*    <Page*/}
      {/*        className="Page"*/}
      {/*        pageNumber={pageNumber}*/}
      {/*        renderTextLayer={false}*/}
      {/*    />*/}
      {/*</Document> {/*<Document*/}
      {/*    file={cv}*/}
      {/*    onLoadSuccess={(e) => {*/}
      {/*        load_success(e)*/}
      {/*        setPages(e.numPages)*/}
      {/*        setSuccess('PagesShow')*/}
      {/*    }}*/}
      {/*    renderMode="svg"*/}
      {/*    width={'100%'}*/}
      {/*    onZoom={true}*/}
      {/*    noData={*/}
      {/*        <div className="loading_pdf">*/}
      {/*            <p>No hay archivo.</p>*/}
      {/*        </div>*/}
      {/*    }*/}
      {/*    height={'auto'}*/}
      {/*    error={*/}
      {/*        error ?*/}
      {/*            <div className="loading_pdf">*/}
      {/*                <p>Error, archivo corrupto.</p>*/}
      {/*                <p>Hemos intentado convertir el archivo, pero fallamos en el intento.</p>*/}
      {/*            </div>*/}
      {/*            :*/}
      {/*            <div className="loading_pdf">*/}
      {/*                <BarLoader*/}
      {/*                    sizeUnit={"px"}*/}
      {/*                    size={750}*/}
      {/*                    color={'#F3764F'}*/}
      {/*                />*/}
      {/*                <p>Archivo .{fileID[1]}, intentando convertir.</p>*/}
      {/*                <p>Espere por favor...</p>*/}
      {/*                <p>Al convertir el archivo podría modificarse ligeramente.</p>*/}
      {/*            </div>*/}
      {/*    }*/}
      {/*    loading={*/}
      {/*        <div className="loading_pdf">*/}
      {/*            <BarLoader*/}
      {/*                sizeUnit={"px"}*/}
      {/*                size={750}*/}
      {/*                color={'#F3764F'}*/}
      {/*            />*/}
      {/*            <p>Cargando PDF</p>*/}
      {/*        </div>*/}
      {/*    }*/}
      {/*>*/}
      {/*    <Page*/}
      {/*        className="Page"*/}
      {/*        pageNumber={pageNumber}*/}
      {/*        renderTextLayer={false}*/}
      {/*    />*/}
      {/*</Document>*/}
    </MainContainer>
  );
};

export default ViewPDF;
